/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseEditorialWrapperFragment, EditorialWrapperFragment, FullEditorialWrapperFragment} from '@amblique/contentful/app/contentful/fragments/editorial-wrapper';

/**
 * Get a single EditorialWrapper by ID (base - scalars only)
 */
export const getBaseEditorialWrapperById = gql`
  ${BaseEditorialWrapperFragment}

  query GetBaseEditorialWrapperById($id: String!, $locale: String!, $preview: Boolean) {
    editorialWrapper(id: $id, locale: $locale, preview: $preview) {
      ...BaseEditorialWrapperFragment
    }
  }
`;

/**
 * Get a single EditorialWrapper by ID (standard - 1 level deep)
 */
export const getEditorialWrapperById = gql`
  ${EditorialWrapperFragment}

  query GetEditorialWrapperById($id: String!, $locale: String!, $preview: Boolean) {
    editorialWrapper(id: $id, locale: $locale, preview: $preview) {
      ...EditorialWrapperFragment
    }
  }
`;

/**
 * Get a single EditorialWrapper by ID (full - 2 levels deep)
 */
export const getFullEditorialWrapperById = gql`
  ${FullEditorialWrapperFragment}

  query GetFullEditorialWrapperById($id: String!, $locale: String!, $preview: Boolean) {
    editorialWrapper(id: $id, locale: $locale, preview: $preview) {
      ...FullEditorialWrapperFragment
    }
  }
`;

/**
 * Get all EditorialWrapper entries with pagination (base - scalars only)
 */
export const getBaseEditorialWrappers = gql`
  ${BaseEditorialWrapperFragment}

  query GetBaseEditorialWrappers(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [EditorialWrapperOrder]
    $where: EditorialWrapperFilter
    $preview: Boolean
  ) {
    editorialWrapperCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseEditorialWrapperFragment
      }
    }
  }
`;

/**
 * Get all EditorialWrapper entries with pagination (standard - 1 level deep)
 */
export const getEditorialWrappers = gql`
  ${EditorialWrapperFragment}

  query GetEditorialWrappers(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [EditorialWrapperOrder]
    $where: EditorialWrapperFilter
    $preview: Boolean
  ) {
    editorialWrapperCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...EditorialWrapperFragment
      }
    }
  }
`;

/**
 * Get all EditorialWrapper entries with pagination (full - 2 levels deep)
 */
export const getFullEditorialWrappers = gql`
  ${FullEditorialWrapperFragment}

  query GetFullEditorialWrappers(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [EditorialWrapperOrder]
    $where: EditorialWrapperFilter
    $preview: Boolean
  ) {
    editorialWrapperCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullEditorialWrapperFragment
      }
    }
  }
`;
